import React from "react"
import L10n from "lib/carrot-l10n"
import DefaultMarkdown from "components/views/DefaultMarkdown"
import ReimbursementsList from "components/views/reimbursements/reimbursementsList/ReimbursementsList"
import Wrapper from "components/views/Wrapper"
import { BenefitResourcesSideBar } from "./BenefitResources"
import { useSelector } from "react-redux"
import { Redirect, withRouter } from "react-router-dom"
import { getUserInfoLoaded } from "reducers/userInfo"
import { useToggle } from "utils/Hooks"
import { PageHeader } from "../molecules/Molecules"
import ReimbursementsThermometer from "./Thermometer"
import { UpdateBankInfoModal } from "../../containers/reimbursements/UpdateBankInfoModal"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { BodyWithRightSidebarLayout } from "../atoms/layouts/BodyWithRightSidebarLayout"
import { Button } from "../atoms/buttons/Button"
import { Spacer } from "components/views/atoms/Atoms"
import { getSubsidyStatus } from "reducers/subsidyStatus"
import { ReimbursementsModalContainer } from "../../containers/reimbursements/ReimbursementsModalContainer"
import { getShouldFillOutBankInfo } from "derivedSelectors/index"
import { BenefitEnrollmentFlowContainer } from "components/csd-enrollment"
import { useBenefitEnrollment } from "../../context/enrollment/BenefitEnrollmentContext"
import EnrollmentReminder from "./enrollment-reminders"
import { BenefitAvailabilityStatus } from "types/benefitEnrollmentStatus"
import { useFeatureToggle } from "components/context/feature-toggle/FeatureToggleContext"
import { Button as CaroteneButton } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const PlanNotStarted = () => (
  <Wrapper medium>
    <div className="lh-copy overflow-hidden w-100 h-100 br3-ns pa5-ns pa3 black-80">
      <DefaultMarkdown source={l`client.reimbursements.planStarted`} />
    </div>
  </Wrapper>
)

const SubmitReimbursementsButton = withRouter(({ history }) => {
  const shouldShowBankInfoModal = useSelector(getShouldFillOutBankInfo)
  const [isUpdateBankInfoModalOpen, toggleIsUpdateBankInfoModalOpen] = useToggle(false)
  const [isReimbursementsModalOpen, toggleIsReimbursementsModalOpen] = useToggle(false)
  const { showMultiYearCsd } = useFeatureToggle()

  const { availabilityStatus } = useBenefitEnrollment()

  const onNavigateToUpload = () => {
    if (shouldShowBankInfoModal) {
      toggleIsUpdateBankInfoModalOpen()
    } else {
      toggleIsReimbursementsModalOpen()
    }
  }
  const isGetReimbursementsDisabled =
    showMultiYearCsd && availabilityStatus !== BenefitAvailabilityStatus.DOES_NOT_NEED_ENROLLMENT

  return (
    <>
      <CaroteneButton
        onClick={onNavigateToUpload}
        variant="secondary"
        disabled={isGetReimbursementsDisabled}
      >{l`Get reimbursed`}</CaroteneButton>
      {isUpdateBankInfoModalOpen && <UpdateBankInfoModal onClose={toggleIsUpdateBankInfoModalOpen} />}
      {isReimbursementsModalOpen && (
        <ReimbursementsModalContainer
          onClose={toggleIsReimbursementsModalOpen}
          onFinish={toggleIsReimbursementsModalOpen}
        />
      )}
    </>
  )
})

const ReimbursementHeader = () => (
  <PageHeader icon="icn-transactions" title={l`client.reimbursements.title`} button={<SubmitReimbursementsButton />} />
)

const ReimbursementsScreen = () => {
  const { availabilityStatus } = useBenefitEnrollment()
  const { showMultiYearCsd } = useFeatureToggle()
  const [showBenefitEnrollmentModal, toggleBenefitEnrollmentModal] = useToggle(false)
  const [showEnrollmentReminder, toggleEnrollmentReminder] = useToggle(
    availabilityStatus !== BenefitAvailabilityStatus.DOES_NOT_NEED_ENROLLMENT
  )

  return (
    <>
      <MasterLayout header={<ReimbursementHeader />}>
        <BodyWithRightSidebarLayout sidebar={<BenefitResourcesSideBar />} bottomContent={<ReimbursementsList />}>
          <ReimbursementsThermometer />
          <Spacer height={3} expand />
        </BodyWithRightSidebarLayout>
      </MasterLayout>
      {showMultiYearCsd && showEnrollmentReminder && (
        <EnrollmentReminder
          availabilityStatus={availabilityStatus}
          onExit={() => toggleEnrollmentReminder()}
        ></EnrollmentReminder>
      )}
      {showBenefitEnrollmentModal && <BenefitEnrollmentFlowContainer onExit={toggleBenefitEnrollmentModal} />}
    </>
  )
}

const Transactions = () => {
  const subsidyStatus = useSelector(getSubsidyStatus)
  const userInfoLoaded = useSelector(getUserInfoLoaded)
  const { availabilityStatus } = useBenefitEnrollment()

  if (availabilityStatus === BenefitAvailabilityStatus.NEEDS_BENEFIT_ENROLLMENT) {
    return <Redirect to={"/#needs-benefit-enrollment"} />
  }

  if (userInfoLoaded) {
    if (!subsidyStatus.planStarted) {
      return <PlanNotStarted />
    }
    return <ReimbursementsScreen />
  } else {
    return null
  }
}

export default Transactions
